export const AuthConstants = {
    LOGIN: "LOGIN",
    FORGOT_PASSWORD: "FORGOT_PASSWORD",
    RESET_PASSWORD: "RESET_PASSWORD",
    PROFILE: "PROFILE",
    UPDATE_PROFILE: "UPDATE_PROFILE",
    CHANGE_PASSWORD: "CHANGE_PASSWORD",
}
